"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isExternalChatOrganization(object) {
    return checkExternalChatOrganization(object).fulfilled;
}
exports.isExternalChatOrganization = isExternalChatOrganization;
function checkExternalChatOrganization(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasString("name"), __1.hasString("authenticationType"), __1.hasChoice("state", ["active", "inactive"]), __1.hasObject("location", __1.hasString("name").optional()).optional(), __1.hasArray("icons", __1.isRecord(__1.hasString("location"), __1.hasString("mimeType"), __1.hasNumber("width").optional())).optional()).withOptions(options).explain();
}
exports.checkExternalChatOrganization = checkExternalChatOrganization;
//# sourceMappingURL=ExternalChatOrganization.js.map